export const initialBoard = {
    columns: [
        {
            id: 0,
            title: "",
            column: "x",
            backgroundColor: "#fff",
            canCollapse: true,
            cards: []
        },
        {
            id: 1,
            title: "new",
            column: "new",
            backgroundColor: "#fff",
            canCollapse: true,
            cards: []
        },
        {
            id: 2,
            title: "toBeCalled",
            column: "to_be_called",
            canCollapse: false,
            cards: []
        },
        {
            id: 3,
            title: "notReached",
            column: "not_reached",
            canCollapse: false,
            cards: []
        },
        {
            id: 4,
            title: "called",
            column: "called",
            canCollapse: false,
            cards: []
        },
        {
            id: 5,
            title: "underReview",
            column: "under_review",
            canCollapse: false,
            cards: []
        },
        {
            id: 6,
            title: "hired",
            column: "hired",
            canCollapse: false,
            cards: []
        }
    ]
}

export const ratings = ['a', 'b', 'c', 'x'];

export function candidatesDtoToBoard(candidatesDto) {
    const board = JSON.parse(JSON.stringify(initialBoard));
    for(var i = 0; i<candidatesDto.length; i++) {
        const card = candidateDtoToCard(candidatesDto[i]);
        for (var j = 0; j<board.columns.length; j++) {
            if (card.columnId == board.columns[j].id) {
                if (card.rating == 3) {
                    // lowest ranking should actually be sorted highest, so we add them at the start of the array
                    // they should already be sorted by date from the backend
                    board.columns[j].cards.unshift(card);
                } else {
                    board.columns[j].cards.push(card);
                }
                break;
            }
        }
    }
    return board;
}

function boardStateToColumnId(boardState) {
    switch (boardState) {
        case 'NEW': 
            return 1;
        case 'TO_BE_CALLED':
            return 2;
        case 'NOT_REACHED': 
            return 3;
        case 'CALLED': 
            return 4;
        case 'UNDER_REVIEW': 
            return 5;
        case 'HIRED': 
            return 6;
        default: 
            return 0;
    }
}

export function columnIdToBoardState(columnId) {
    switch (columnId) {
        case 1: 
            return 'NEW';
        case 2:
            return 'TO_BE_CALLED';
        case 3: 
            return 'NOT_REACHED';
        case 4: 
            return 'CALLED';
        case 5: 
            return 'UNDER_REVIEW';
        case 6: 
            return 'HIRED';
        default: 
            return 'HIDDEN';
    }
}

export function candidateDtoToCard(candidateDto) {
    const columnId = boardStateToColumnId(candidateDto.boardState);
    const card = {
        id: candidateDto.email,
        fullName: candidateDto.fullName,
        email: candidateDto.email,
        phone: candidateDto.phoneNumber,
        location: candidateDto.location, 
        rating: candidateDto.rank,
        columnId: columnId,
        createdAt: candidateDto.createdAt,
        isCardVisible: true,
        isCardSelected: false,
        emailSent: candidateDto.emailSent,
        form: candidateDto.fullQuestionForm,
        comments: candidateDto.comments.map((comment) => ({
            id: comment.id,
            email: comment.creatorEmail,
            content: comment.comment,
            createdAt: comment.createdAt
        }))
    }
    return card;
}

